import CardSystem from '../../Card/CardSystem';
import { UIEvent } from 'System/UI/BaseUISystem';
import { PlayAnimation } from 'System/Animation/AnimationHelper';
import AnimationClip from 'System/Animation/AnimationClip';
import BaseCard from 'Prototype/Level/Card/BaseCard';
import Renderable from 'Component/Renderable';
import Interactable from 'Component/Interactable';
import CardComponent from 'Component/Level/Card';
import { MainAnim } from './MainAnim';
import { Easing, Interpolation } from '@tweenjs/tween.js';

interface IUseCanisterPreBoosterMeta {
    system: CardSystem;
}

export class UseCanisterPreBooster extends AnimationClip<IUseCanisterPreBoosterMeta> {
    public *execute(card: BaseCard, meta: IUseCanisterPreBoosterMeta): IterableIterator<number> {
        card.getComponent(Interactable).enabled = false;
        card.getComponent(CardComponent).animating = true;

        yield* PlayAnimation(
            new MainAnim(
                card,
                {
                    alpha: 0,
                    duration: 500,
                    easing: Easing.Sinusoidal.Out,
                    interpolation: Interpolation.Bezier,
                },
                true
            )
        );
        card.getComponent(Renderable).visible = false;
        meta.system.cardStack.update();

        meta.system.scene.emit(UIEvent.RESTORE_INTERACTIVITY, true);
    }
}
